import { render } from "./TransactionsPage.vue?vue&type=template&id=a9a65978&scoped=true"
import script from "./TransactionsPage.vue?vue&type=script&lang=js"
export * from "./TransactionsPage.vue?vue&type=script&lang=js"

import "./TransactionsPage.vue?vue&type=style&index=0&id=a9a65978&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a65978"]])

export default __exports__